import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { SCSS_COLORS } from '../../../../../colors';
import { PrivateClassLesson } from '../private-class-lesson-dto';

const colors = SCSS_COLORS;

@Component({
  selector: 'lp2-private-class-lesson-container',
  templateUrl: './private-class-lesson-container.component.html',
  styleUrls: ['./private-class-lesson-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrivateClassLessonContainerComponent implements OnChanges {
  @Input() lesson?: PrivateClassLesson;
  @Input() checked: boolean;
  @Input() displayCheckbox = false;
  @Output() selected: EventEmitter<number> = new EventEmitter();

  public hovered = false;
  public colors = colors;
  public color: string;

  @HostListener('mouseenter') onMouseEnter() {
    this.hovered = true;
  }

  @HostListener('mouseleave') onMouseLeave() {
    this.hovered = false;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.color =
      changes.displayCheckbox && changes.displayCheckbox.currentValue
        ? colors['$white']
        : colors['$pc-scroll-bar-light-blue'];
  }

  public updateSelection() {
    if (!this.displayCheckbox) {
      return;
    }
    this.selected.emit(this.lesson ? this.lesson.id : -1);
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-revamp/private-class-banner/private-class-lesson-container/private-class-lesson-container.component.ts